import script from "./TaskEditModeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskEditModeCard.vue?vue&type=script&setup=true&lang=js"

import "./TaskEditModeCard.vue?vue&type=style&index=0&id=e5ce4634&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5ce4634"]])

export default __exports__